import { useEffect, useState } from 'react'
import getPermission, { usePermission } from '@fs/zion-permissions'
import { useUser } from '@fs/zion-user'
import { formatISO } from '@fs/zion-locale/date-fns'
import zionDebug from '@fs/zion-debug'

export default function useQualifiesForAccount() {
  const debug = zionDebug('majorAccounts:useQualifiesForAccount:useQualifiesForAccount')
  const [isAuthorized, setAuthorized] = useState()
  const { birthDate, userLoading } = useUser()
  const [formattedBirthDate, setFormattedBirthDate] = useState('')
  const [isMember, isMemberStatus] = usePermission('FtMemberUiPermission')

  useEffect(() => {
    if (birthDate) {
      const birthDateFormatted = formatISO(new Date(birthDate), { representation: 'date' })
      setFormattedBirthDate(birthDateFormatted)
    }
  }, [birthDate])

  useEffect(() => {
    let cancelled = false
    async function fetchData() {
      let qualifies = false
      try {
        const { authorized } = await getPermission(
          'PtnrQualifiesForAccountPermission',
          'PtnrFreeAccessContext',
          `DelayedDateActivator.StartDate:${formattedBirthDate}`
        )
        qualifies = authorized
        !cancelled && setAuthorized(qualifies)
      } catch (e) {
        !cancelled && console.error(e)
      }
      return qualifies
    }
    if (!userLoading && !birthDate) {
      setAuthorized(false)
    }
    if (!userLoading && isMemberStatus === 'loaded' && birthDate) {
      fetchData().then((r) => debug('fetchData:qualifies: ', r))
    } else {
      debug('Waiting on birth date and member status')
    }
    return () => {
      cancelled = true
    }
  }, [birthDate, userLoading, isMember, isMemberStatus])

  return isAuthorized
}
